import { createSlice } from '@reduxjs/toolkit'

export interface SelectedOptionsState {
  selectedOptions: { key: string; name: string; value: boolean }[]
}

const initialState: SelectedOptionsState = {
  selectedOptions: [],
}

const selectedOptionsSlice = createSlice({
  name: 'selectedOptions',
  initialState,
  reducers: {
    setSelectedOptions(state, action) {
      state.selectedOptions = action.payload
    },
    clearSelectedOptions(state) {
      state.selectedOptions = initialState.selectedOptions
    },
  },
})

export const { setSelectedOptions, clearSelectedOptions } =
  selectedOptionsSlice.actions
export default selectedOptionsSlice.reducer
